import { Form, Input, Typography } from 'antd';
import { AiOutlineLock } from 'react-icons/ai';
import { useHistory, useParams } from 'react-router-dom';

import { AuthLayout } from '../../../components/AuthLayout';
import { Button } from '../../../components/Common/Button';
import { Logo } from '../../../components/Common/Logo';
import { useMobileVersion } from '../../../hooks/useMobileVersion';
import { registerUser } from '../../../operations/users';
import * as authRules from '../../../rules/auth';
import { ContainerAuth, FormAuth, LinkAuth } from '../../../styles/common/auth';
import { ContentStyled, TitleStyled } from './styles';

const { Title, Paragraph } = Typography;

type Params = {
  apiToken: string;
  companyName: string;
};

export const Register = () => {
  const history = useHistory();
  const { apiToken, companyName } = useParams<Params>();
  const isMobileVersion = useMobileVersion();

  const handleSubmit = async (values: any) => {
    await registerUser(apiToken, values.password, values.passwordConfirm);
    history.push('/login');
  };

  const RegisterPasswordForm = () => (
    <FormAuth
      id="passwordRegisterForm"
      onFinish={handleSubmit}
      style={{ minWidth: 330 }}
    >
      <Form.Item name="password" rules={authRules.password} hasFeedback>
        <Input.Password
          prefix={<AiOutlineLock />}
          placeholder="Senha"
          size="large"
        />
      </Form.Item>

      <Form.Item
        name="passwordConfirm"
        dependencies={['password']}
        rules={authRules.passwordConfirm}
        hasFeedback
      >
        <Input.Password
          prefix={<AiOutlineLock />}
          placeholder="Repetir senha"
          size="large"
        />
      </Form.Item>
    </FormAuth>
  );

  if (isMobileVersion) {
    return (
      <ContainerAuth>
        <Logo height={35} />
        <TitleStyled>
          Bem-vindo ao painel contábil para sua empresa {companyName}
        </TitleStyled>
        <ContentStyled>
          <h2>Cadastrar senha</h2>
          <p>Cadastre sua senha para acessar</p>
          <RegisterPasswordForm />
          <LinkAuth to="/login">Já possuo login</LinkAuth>
          <Button form="passwordRegisterForm" block htmlType="submit">
            Cadastrar senha
          </Button>
        </ContentStyled>
      </ContainerAuth>
    );
  }

  return (
    <AuthLayout>
      <div style={{ maxWidth: 330, textAlign: 'center' }}>
        <Title level={4} style={{ textAlign: 'center' }}>
          Bem-vindo ao painel contábil para sua empresa {companyName}
        </Title>
        <Paragraph style={{ fontSize: '20px', textAlign: 'center' }}>
          Cadastre sua senha para acessar
        </Paragraph>
        <RegisterPasswordForm />
        <Button form="passwordRegisterForm" block htmlType="submit">
          Cadastrar senha
        </Button>
        <LinkAuth style={{ marginTop: '10px' }} to="/login">
          Já possuo login
        </LinkAuth>
      </div>
    </AuthLayout>
  );
};
